<template>
  <b-overlay :show="loading" class="mt-1">
    <add-or-update-minister-stations-modal
      :is-add-or-update-active.sync="isAddOrUpdateActive"
      :update-data="updateData"
      :user-id="userId"
      :is-personal="isPersonal"
      @refetchData="fetch"
      @push="push"
      @resetUpdateData="resetUpdateData"
    />
    <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1">
      <h1 class="text-center">Stations Served (Title, Year)</h1>
      <b-button variant="primary" @click="addStation">
        Add Station
      </b-button>
    </div>
    <div v-for="(station, index) in currentStations" :key="`st1-${index}`">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input v-model="station.title" :readonly="true" class="mt-1" placeholder="Title" />
        </b-col>

        <b-col cols="12" md="6" class="d-flex align-items-center">
          <b-form-input v-model="station.year" :readonly="true" class="mt-1" placeholder="Year" />

          <b-button variant="no-outline" type="button" @click="deleteOldStation(index)">
            <feather-icon icon="TrashIcon" size="20" color="red" />
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div v-for="(station) in tableData" :key="station.id">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input :value="getStationTitle(station)" :readonly="true" class="mt-1" placeholder="Title" />
        </b-col>

        <b-col cols="12" md="6" class="d-flex align-items-center">
          <b-form-input v-model="station.year" :readonly="true" class="mt-1" placeholder="Year" />

          <b-button variant="no-outline" type="button" @click="deleteStation(station._id)">
            <feather-icon icon="TrashIcon" size="20" color="red" />
          </b-button>
        </b-col>
      </b-row>
    </div>

    <div v-if="secondments.length > 0">
      <div v-for="(secondment) in secondments" :key="secondment.id">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input :value="getSecondmentTitle(secondment)" :readonly="true" class="mt-1" placeholder="Title" />
        </b-col>

        <b-col cols="12" md="6" class="d-flex align-items-center">
          <b-form-input v-model="secondment.years" :readonly="true" class="mt-1" placeholder="Year" />

          <b-button variant="no-outline" type="button" :disabled="true">
            <feather-icon icon="ArchiveIcon" size="20" color="red" />
          </b-button>
        </b-col>
      </b-row>
    </div>
    </div>
  </b-overlay>
</template>

<script>
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ListTable from "@core/components/ListTable/ListTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AddOrUpdateMinisterStationsModal from "@core/components/minister-stations/AddOrUpdateMinisterStationsModal.vue";

import { get } from "lodash";
import { BOverlay, BLink, BButton, BModal, BRow, BCol, BTooltip, BAvatar, BMedia, BBadge, BDropdown, BDropdownItem, BFormInput } from "bootstrap-vue";

const watchHandler = {
  handler(){
    this.debounceFetch()
  },
  immediate: false
}

const watchHandlerRequiresPageReset = {
  handler(){
    this.currentPage = 1;
    this.debounceFetch()
  },
  immediate: false
}

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BModal,
    BMedia,
    BBadge,
    BButton,
    vSelect,
    BAvatar,
    BTooltip,
    BOverlay,
    ListTable,
    BDropdown,
    BFormInput,
    BDropdownItem,
    AddOrUpdateMinisterStationsModal
  },
  directives: {
    Ripple,
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    isPersonal: {
      type: Boolean,
      default: false
    },
    currentStations: {
      type: Array,
      required: false,
      default: () => []
    },
    profileId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      secondments: [],

      search: "",
      updateData: null,
      debounceFetch: null,
      isAddOrUpdateActive: false,
    }
  },
  computed: {
    perPage: {
      get() {
        return this.$store.getters[`navigation/recordsPerPage`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_RECORDS_PER_PAGE`, value)
      }
    },
    currentPage: {
      get() {
        return this.$store.getters[`navigation/currentPage`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_CURRENT_PAGE_NUMBER`, value)
      }
    },
    totalRecords: {
      get(){
        return this.$store.getters[`navigation/totalRecords`];
      },
      set(value){
        this.$store.commit(`navigation/UPDATE_TOTAL_RECORDS`, value)
      }
    },
  },
  watch: {
    currentPage: watchHandler,
    search: watchHandlerRequiresPageReset,
    perPage: watchHandlerRequiresPageReset,
  },
  created() {
    console.log("created minister stations", this.currentStations)
    this.fetch();
  },
  methods: {
    async fetch() {
      try {
        this.loading = true;

        const query = {
          limit: this.perPage,
          search: this.search,
          page: this.currentPage,
        }
        if (!this.isPersonal) {
          query.user_id = this.userId;
        }
        await this.$router.push({ query }).catch(() => {});

        const apiService = this.useJwt().mainService.stationsServed;

        const request = await apiService.list(query);
        const { data, pagination, secondments = [] } = request.data;

        this.secondments = secondments;
        this.totalRecords = pagination.totalRecords;
        this.perPage = pagination.limit;
        this.tableData = data;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async deleteStation(id){
      try {
        this.loading = true;

        const result = await this.$swal({
          title: 'Confirm Delete?',
          text: "Do you want to delete this record?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed.',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.value) {
          return;
        }

        const apiService = this.useJwt().mainService.stationsServed;

        await apiService.delete(id);
        await this.fetch()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: 'Service record deleted successfully'
          },
        });
      } catch (error) {
        const error_message = get(error, "response.statusText") || error.message;

        this.$nextTick(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error_message
            },
          });
        })
      } finally {
        this.loading = false;
      }
    },
    async deleteOldStation(index){
      try {
        this.loading = true;

        const result = await this.$swal({
          title: 'Confirm Delete?',
          text: "Do you want to delete this record?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed.',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.value) {
          return;
        }

        // remove station from current stations
        this.currentStations.splice(index, 1);
        await this.useJwt().mainService.memberProfiles.updateStations(this.profileId, { stations: this.currentStations });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: 'Service record deleted successfully'
          },
        });
      } catch (error) {
        const error_message = get(error, "response.statusText") || error.message;

        this.$nextTick(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error_message
            },
          });
        })
      } finally {
        this.loading = false;
      }
    },
    onEdit(update){
      this.updateData = update;
      this.isAddOrUpdateActive = true;
    },
    addStation() {
      this.isAddOrUpdateActive = true;
    },
    resetUpdateData(){
      if (this.updateData){
        this.updateData = null
      }
    },
    getSecondmentTitle(secondment) {
      return secondment.job_title + ', ' + secondment.location;
    },
    push(data) {
      this.tableData.push(data);
    }
  }
}
</script>

<style scoped>

</style>

<style>
[dir] .form-control:disabled, [dir] .form-control[readonly] {
  background-color: unset;
  opacity: 1;
}
</style>
